import { render, staticRenderFns } from "./AddUserAddress.vue?vue&type=template&id=519c696a&scoped=true"
import script from "./AddUserAddress.vue?vue&type=script&lang=js"
export * from "./AddUserAddress.vue?vue&type=script&lang=js"
import style0 from "./AddUserAddress.vue?vue&type=style&index=0&id=519c696a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519c696a",
  null
  
)

export default component.exports